export default __webpack_public_path__ + "static/media/portfolio-76.a23499b2.jpg";